import { React, Link, Image, styled, mq } from 'x'
import { Content, Row, Col } from 'components/common'

const Container = styled.div`
  @media (min-width: 2000px) {
    max-width: ${(props) => (props.isBlog ? 'auto' : '100%')};
    flex: ${(props) => (props.isBlog ? '0 1 auto' : 'initial')};
  }

  background-color: #fff;
  padding: 100px 0;
  position: relative;
  max-width: 30%;
  flex: 0 1 30%;

  ${mq.below('md')} {
    flex: 1 1 100%;
    max-width: 100%;
  }

  ${mq.below('sm')} {
    padding: 60px 0;
  }
`
const StyledContent = styled(Content)`
  padding: 0 100px 0 30px;
  margin-left: 0;
  max-width: 700px;
  ${mq.below('lg')} {
    padding: 0 30px;
    max-width: 100%;
  }
`

const Filters = styled(Row)`
  margin: 0 -2.5px;
`
const Filter = styled(Col)`
  padding: 0 2.5px;
  flex: 0 1 auto;
  margin-bottom: 10px;
`
const FilterLink = styled(Link)`
  width: auto;
  float: left;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  margin-right: 10px;
  display: block;
  color: #2a2e57;
  background-color: #f2f2f2;
  font-weight: 700;
  font-size: 17px;
  line-height: 27.2px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #2a2e57;
    color: #f2f2f2;
  }
`

const FilterTitle = styled.div``

const BlogTopicsFilter = (props) => {
  if (!props.extra.blogTopics) {
    return null
  }
  return (
    <Container>
      <StyledContent>
        <p>Filter:</p>
        <Filters>
          {props.extra.blogTopics.map((filter, index) => (
            <Filter key={filter.id}>
              <FilterLink to={props.globalData.formatLink(filter.link)}>
                <FilterTitle>{filter.title}</FilterTitle>
              </FilterLink>
            </Filter>
          ))}
        </Filters>
      </StyledContent>
    </Container>
  )
}

export default BlogTopicsFilter
